import React from 'react';
import { DashboardScreen } from '../features/dashboard/components/DashboardScreen';

const HomeScreen = () => {
  console.log('HomeScreen renderizado');
  return <DashboardScreen />;
};

export default HomeScreen; 